import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Subscription, timer } from 'rxjs';

@Component({
    selector: 'animated-ellipsis',
    template: `{{frameShow}}<span style="visibility:hidden">{{frameHide}}</span>`,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AnimatedEllipsisComponent {

  public frameShow: string;
  public frameHide: string;
  private timer: Subscription;

  private ngOnInit(): void {
    const frames: string[] = ['', '.', '..', '...'];
    this.timer = timer(0, 500).subscribe(i => {
      const frame = i % frames.length;
      this.frameShow = frames[frame];
      this.frameHide = frames[frames.length - 1 - frame];
    });
  }

  private ngOnDestroy(): void {
    this.timer?.unsubscribe();
  }
}
